import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserManagementResult } from '../models/UserManagement/user-management-result';
import { GroupsHolder } from '../models/UserManagement/groups-holder';
import { UserGroup } from '../models/UserManagement/user-group';
import { SaveUser } from '../models/UserManagement/save-user';
import { NewUserResult } from '../models/UserManagement/new-user-result';
import { UserLocationsHolder } from '../models/UserManagement/user-locations-holder';
import { UserLocation } from '../models/UserManagement/user-location';
import { AuditLocation } from '../models/Locations/audit-location';
import { BasicUser } from '../models/basic-user';
import { BasicResult } from '../models/basic-result';
import { UserAudit } from '../models/UserManagement/user-audit';
import { TrialSignupOptions } from '../models/Trial/trial-signup-options';
import { UserSettingsPermissionsResult } from '../models/UserManagement/user-settings-permissions-result';
import { LocationAudit } from '../models/UserManagement/location-audit';
import { EditAuditLocationResult } from '../models/Locations/edit-audit-location-result';
import { AuditUserResult } from '../models/UserManagement/audit-user-result';
import { AuditUser } from '../models/UserManagement/audit-user';
import { UserPermissionsRequest } from '../models/UserManagement/user-permissions-request';
import { UserPermissionsLocationListRequest } from '../models/UserManagement/user-permissions-location-list-request';
import { UserLocationLocationSave } from '../models/UserManagement/user-location-location-save';
import { UserAuditResult } from '../models/UserManagement/user-audit-result';
import { HttpResponse } from '@capacitor/core';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

  constructor(private httpClient: HttpClient) {
  }
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    observe: 'response' as 'response',
    responseType: 'json' as const,
    withCredentials: true,
  };
  userManagementList(UPR: UserPermissionsRequest): Observable<UserManagementResult> {
    return this.httpClient.post<UserManagementResult>(`${environment.apiUrl}users/getuserlistnew`, UPR, this.httpOptions).pipe(
      map((res:any) => {
        return new UserManagementResult(res.body!);
      })
    );
  }
  userManagementListByLocations(request: UserPermissionsLocationListRequest): Observable<UserManagementResult> {
    return this.httpClient.post<UserManagementResult>(`${environment.apiUrl}users/getuserlistbylocations`, request, this.httpOptions).pipe(
      map((res:any) => {
        return new UserManagementResult(res.body!);
      })
    );
  }
  saveUserManagementList(result: UserManagementResult): Observable<UserManagementResult> {
    return this.httpClient.post<UserManagementResult>(`${environment.apiUrl}users/savecurrentuserpermissions`, result, this.httpOptions).pipe(
      map((res:any) => {
        return new UserManagementResult(res.body!);
      })
    );
  }
  getGroupList(): Observable<GroupsHolder> {
    return this.httpClient.get<GroupsHolder>(`${environment.apiUrl}users/getGroups`, this.httpOptions).pipe(
      map((res:any) => {
        return new GroupsHolder(res.body!);
      })
    );
  }
  saveGroupUpdate(groupReturn: UserGroup): Observable<GroupsHolder> {
    return this.httpClient.post<GroupsHolder>(`${environment.apiUrl}users/savegroupusers`, groupReturn, this.httpOptions).pipe(
      map((res:any) => {
        return new GroupsHolder(res.body!);
      })
    );
  }
  newUser(newUser: SaveUser): Observable<NewUserResult> {
    return this.httpClient.post<NewUserResult>(`${environment.apiUrl}users/savenewuser`, newUser, this.httpOptions).pipe(
      map((res:any) => {
        return new NewUserResult(res.body!);
      })
    );
  }

  getUserLocationsList(isGroup: boolean): Observable<UserLocationsHolder> {
    return this.httpClient.post<UserLocationsHolder>(`${environment.apiUrl}users/getlocationusers`, isGroup, this.httpOptions).pipe(
      map((res:any) => {
        return new UserLocationsHolder(res.body!);
      })
    );
  }
  saveUserLocationChange(location: UserLocation): Observable<boolean> {
    return this.httpClient.post<boolean>(`${environment.apiUrl}users/savelocationusers`, location, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  getEditableLocations(): Observable<AuditLocation[]> {
    return this.httpClient.get<AuditLocation[]>(`${environment.apiUrl}locations/geteditlocations`, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  getManageUsers(isGroup: boolean): Observable<SaveUser[]> {
    return this.httpClient.post<SaveUser[]>(`${environment.apiUrl}users/getmanageusers`, isGroup, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  saveManageUsers(updatedUser: SaveUser): Observable<BasicResult> {
    return this.httpClient.post<BasicResult>(`${environment.apiUrl}users/savemanageduser`, updatedUser, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  hasAvailableUserLicense(): Observable<boolean> {
    return this.httpClient.get<boolean>(`${environment.apiUrl}users/hasavailableuserlicense`, this.httpOptions).pipe(
      map((res:any) => res.body!)
    );
  }
  checkManagedUserEmail(updatedUser: SaveUser): Observable<BasicResult> {
    return this.httpClient.post<BasicResult>(`${environment.apiUrl}users/checkmanageduseremail`, updatedUser, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  getUserProfile(): Observable<SaveUser> {
    return this.httpClient.get<SaveUser>(`${environment.apiUrl}users/getprofile`, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  saveUserProfile(userUpdate: SaveUser): Observable<NewUserResult> {
    return this.httpClient.post<NewUserResult>(`${environment.apiUrl}users/saveprofile`, userUpdate, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  manageLicenses(): Observable<string> {
    return this.httpClient.post<string>(`${environment.apiUrl}licensing/createportalsession`, {}, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  getUserAudits(isGroup: boolean): Observable<UserAudit[]> {
    return this.httpClient.post<UserAudit[]>(`${environment.apiUrl}users/getuserauditlist`, isGroup, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  getUserAuditUserList(isGroup: boolean): Observable<UserAuditResult> {
    return this.httpClient.post<UserAuditResult>(`${environment.apiUrl}users/getuseraudituserlist`, isGroup, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  getIndividualUserAudits(userID: number): Observable<UserAuditResult> {
    return this.httpClient.post<UserAuditResult>(`${environment.apiUrl}users/getindividualuserauditlist`, userID, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      }));
  }
  saveIndividualUserAudits(audits: UserAudit): Observable<UserAuditResult> {
    return this.httpClient.post<UserAuditResult>(`${environment.apiUrl}users/saveindividualuseraudit`, audits, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  getLocationAudits(locationID: number): Observable<LocationAudit[]> {
    return this.httpClient.post<LocationAudit[]>(`${environment.apiUrl}users/getlocationauditlist`, locationID, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  saveLocationAudits(audits: LocationAudit[]): Observable<BasicResult> {
    return this.httpClient.post<BasicResult>(`${environment.apiUrl}users/savelocationauditlist`, audits, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  saveUserAuditChange(userUpdate: UserAudit): Observable<BasicResult> {
    return this.httpClient.post<BasicResult>(`${environment.apiUrl}users/saveuseraudit`, userUpdate, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  createCheckoutSession(signup: TrialSignupOptions): Observable<string> {
    return this.httpClient.post<string>(`${environment.apiUrl}licensing/trialsignup`, signup, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  createShowTrial(signup: TrialSignupOptions): Observable<BasicResult> {
    return this.httpClient.post<BasicResult>(`${environment.apiUrl}licensing/showtrialsignup`, signup, this.httpOptions).pipe(
      map((res:any) => {
        return new BasicResult(res.body!);
      })
    );
  }
  finaliseTrial(GUID: string, SessionID: string): Observable<string> {
    return this.httpClient.post<string>(`${environment.apiUrl}licensing/trialfinalise`, { "GUID": GUID, "SessionID": SessionID }, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  userSettingsPermissions(): Observable<UserSettingsPermissionsResult> {
    return this.httpClient.get<UserSettingsPermissionsResult>(`${environment.apiUrl}users/getsettingsfeatures`, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  getLocationAuditLocations(auditID: number): Observable<EditAuditLocationResult> {
    return this.httpClient.post<EditAuditLocationResult>(`${environment.apiUrl}locations/getlocationauditlocations`, auditID, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  saveLocationAuditLocations(saveAudits: EditAuditLocationResult): Observable<BasicResult> {
    return this.httpClient.post<BasicResult>(`${environment.apiUrl}locations/saveauditlocations`, saveAudits, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  getUserAuditUsers(auditID: number): Observable<AuditUserResult> {
    return this.httpClient.post<AuditUserResult>(`${environment.apiUrl}users/getuserauditusers`, auditID, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  saveUserAuditUsers(updatedUsers: AuditUser[]): Observable<AuditUserResult> {
    return this.httpClient.post<AuditUserResult>(`${environment.apiUrl}users/saveuserauditusers`, updatedUsers, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  getUserManagementLocations(): Observable<AuditLocation[]> {
    return this.httpClient.get<AuditLocation[]>(`${environment.apiUrl}locations/getuserpermissionlocation`, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  getUserLocationUsers(IsGroup: boolean): Observable<BasicUser[]> {
    return this.httpClient.post<BasicUser[]>(`${environment.apiUrl}users/getuserlocationusers`, IsGroup, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  getUserLocationLocations(RequestedUserID: number): Observable<AuditLocation[]> {
    return this.httpClient.post<AuditLocation[]>(`${environment.apiUrl}users/getuserlocationlocations`, RequestedUserID, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  saveUserLocationLocations(locationSave: UserLocationLocationSave): Observable<BasicResult> {
    return this.httpClient.post<BasicResult>(`${environment.apiUrl}users/saveuserlocationchanges`, locationSave, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
    userCampaignPermissions(): Observable<UserSettingsPermissionsResult> {
    return this.httpClient.get<UserSettingsPermissionsResult>(`${environment.apiUrl}users/getcampaignpermission`, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
}
